import { render } from "./AddDnsServer.vue?vue&type=template&id=a907e3b2&scoped=true"
import script from "./AddDnsServer.vue?vue&type=script&lang=js"
export * from "./AddDnsServer.vue?vue&type=script&lang=js"

import "./AddDnsServer.vue?vue&type=style&index=0&id=a907e3b2&lang=less&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a907e3b2"]])

export default __exports__